


















import Vue from "vue";
import Member from "@/components/shared/member/Member.vue";

export default Vue.extend({
  name: "Memeber",
  props: ["title", "members", "buttonOptions"],
  components: {
    Member
  }
});
